import { render } from "./PageGerenciamentoSecretaria.vue?vue&type=template&id=57d5ecdc&scoped=true"
import script from "./PageGerenciamentoSecretaria.vue?vue&type=script&lang=js"
export * from "./PageGerenciamentoSecretaria.vue?vue&type=script&lang=js"

import "./PageGerenciamentoSecretaria.vue?vue&type=style&index=0&id=57d5ecdc&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d5ecdc"]])

export default __exports__